import {IGridStatus} from '../ap-interface/interfaces/ap-grid-status.interface';
import ScanType = Data.NDI.Enums.ScanType;

export enum BestScanType {
  SatelliteScan = 0,
  NFertilizationSensor = 1,
  PlantProtectionSensor = 2
}

export type BestScanData = {
  Status: IGridStatus | undefined;
  SatId: string | undefined;
  PlanId: string | undefined;
  Ec: number | undefined;
  CropTypeId: number | undefined;
  Created: Date | undefined;
  NUptakeMax: number | undefined;
  NUptakeMin: number | undefined;
  NUptakeAvg: number | undefined;
  ScanType: BestScanType | undefined;
  SatelliteScan: ScanType | undefined;
};
